import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaAward } from "react-icons/fa6";
import EmployeeRewards from "./index";

const employeeAwardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Employee Awards",
        basePath: "employee-awards",
        mainComponent: <EmployeeRewards />,
        layout: "/console",	   
        icon: <FaAward className="icon-item" />,
        subTitle:"Employee Award",
        level:5,
        moduleId: 0,
    })
]

export default employeeAwardRoutes;